// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"425":"1405cd6f","5860":"7e853ca0"}[chunkId] + ".chunk.css";
};